<a
	href="#"
	class="text-basecolor"
	(click)="$event.preventDefault(); sort()"
>
	<ng-content></ng-content>
	<!-- @if (isSortedByMeAsc) {
	<span
		class='glyphicon glyphicon-triangle-top'
		aria-hidden='true'
	></span>
	}
	@if (isSortedByMeDesc) {
	<span
		class='glyphicon glyphicon-triangle-bottom'
		aria-hidden='true'
	></span>
	} -->
</a>